import { movies } from "@/mocks/catalog";
import CompactMovie from "@/components/feature/CompactMovie";
import SectionHeading from "@/components/feature/SectionHeading";

const highlights = [
  { icon: "ri-flashlight-line", text: "节奏紧凑，开场即进入冲突，适合一次性看完" },
  { icon: "ri-roadster-line", text: "追车与爆破场面调度密集，视觉信息量大" },
  { icon: "ri-boxing-line", text: "近身格斗讲求真实感，动作设计是主要看点" },
  { icon: "ri-team-line", text: "小队作战与兄弟情感线，让动作之外有情绪落点" },
];

export default function ActionSection() {
  const items = movies.filter((m) => m.genre === "动作片");

  return (
    <section id="action" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="flex flex-col gap-6">
            <SectionHeading
              eyebrow="动作片专区"
              title="动作片：用节奏和身体语言讲故事"
              description="动作片的核心是「推进感」。它通常不依赖复杂台词，而是通过追逐、对抗和协作，把人物关系与情绪直接呈现在画面里，因此很适合想快速进入状态的观众。"
            />
            <ul className="flex flex-col gap-3">
              {highlights.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-base`}></i>
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{item.text}</span>
                </li>
              ))}
            </ul>
            <a
              href="#explorer"
              className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-filter-3-line"></i>
              在片库中筛选动作片
            </a>
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-sm font-medium text-foreground-500">代表作品</p>
            {items.map((movie) => (
              <CompactMovie key={movie.id} movie={movie} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}